import { makeStyles } from "@material-ui/core";

export const miniAppStyles = makeStyles({
    miniAppFrame: {
        width: "100%",
        border: 0,
        flexGrow: 1
    }
});